import { getEnvVariable } from './helpers';

export const CONFIG = {
  ROLLBAR_POST_CLIENT_ITEM_ACCESS_TOKEN: getEnvVariable(
    'REACT_APP_ROLLBAR_POST_CLIENT_ITEM_ACCESS_TOKEN',
  ),
  ENVIRONMENT: getEnvVariable('REACT_APP_ENVIRONMENT'),
  LI3IB_API_BASE_URL: getEnvVariable('REACT_APP_LI3IB_API_BASE_URL'),
};
